/**
 * Checks whether a phone number matches the stored SMS number format.
 *
 * @param {string} phoneNumber Phone number value to validate.
 * @returns {boolean} True when the number is formatted as 123-456-7890.
 */
export const validateSMSPhoneNumber = (phoneNumber) => {
  const regex = /^\d{3}-\d{3}-\d{4}$/;
  return regex.test(phoneNumber);
};

/**
 * Formats US phone digits as the stored SMS number format.
 *
 * @param {string} value Phone input value.
 * @returns {string} Formatted phone number, or an empty string when invalid.
 */
export const formatUSPhoneNumberForSMS = (value) => {
  let digits = (value || "").replace(/\D/g, "");

  if (digits.length === 11 && digits.startsWith("1")) {
    digits = digits.slice(1);
  }

  if (digits.length !== 10) {
    return "";
  }

  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
};

/**
 * Applies SMS phone input behavior and normalizes autofill/paste values.
 *
 * @param {string} value Latest input value from the field.
 * @param {string} previousValue Previous phone number state.
 * @returns {string} Formatted phone number value.
 */
export const formatSMSPhoneNumberInput = (value, previousValue = "") => {
  let formattedValue = value;
  const autofilledValue = formatUSPhoneNumberForSMS(formattedValue);
  const isStoredFormat = validateSMSPhoneNumber(formattedValue);

  if (autofilledValue && !isStoredFormat) {
    return autofilledValue;
  }

  const isDeleting = formattedValue.length < previousValue.length;

  if (!isDeleting) {
    if (formattedValue.length === 3) {
      formattedValue += "-";
    }
    if (formattedValue.length === 7 && formattedValue[3] === "-") {
      formattedValue += "-";
    }
  }

  return formattedValue;
};
